import type { IContributionProjetRepository } from '../../domain/ports/IContributionProjetRepository';
import type { ContributionProjetDTO } from '../dto/dtos';

export interface ListerParEmployeInput  { idEmploye: string; }
export interface ListerParEmployeOutput { contributions: ContributionProjetDTO[]; }

export class ListerContributionsParEmployeUseCase {
  constructor(private readonly repository: IContributionProjetRepository) {}

  async execute(input: ListerParEmployeInput): Promise<ListerParEmployeOutput> {
    const response = await this.repository.listerParEmploye(input.idEmploye);
    if (!response.succes) throw new Error(response.message || 'Erreur lors de la récupération');
    return { contributions: response.data ?? [] };
  }
}
